import React from "react";
import { Badge, ListItem, ListItemText, makeStyles } from "@material-ui/core";
import { ExpandLess, ExpandMore } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
    container: (props) => ({
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        alignItems: "center",
        "&:hover": {
            background: "#F4EEFF",
            borderRadius: "8px",
        },
        [`&.${props.activeClassName}`]: {
            background: "#F4EEFF",
            borderRadius: "8px",
        },
    }),
    label: {
        paddingLeft: "16px",
        paddingRight: "24px",
        gap: "12px",
    },
    labelText: (props) => ({
        color: "#48464A",
        fontWeight: "500",
        [`.${props.activeClassName} &`]: {
            color: "#483795",
            fontWeight: "600",
        },
    }),
    icon: {
        color: "#48464A",
    },
    badge: {
        marginLeft: "auto",
    },
}));

function PlatformSidebarCategory({
    name,
    icon: Icon,
    isOpen = false,
    isCollapsable = false,
    badge = null,
    ...rest
}) {
    const classes = useStyles({ activeClassName: rest.activeClassName });

    return (
        <ListItem {...rest} className={classes.container}>
            <Icon className={classes.icon} />
            <ListItemText className={classes.label} classes={{ primary: classes.labelText }}>{name}</ListItemText>
            {isCollapsable ? (
                isOpen ? (
                    <ExpandLess className={classes.icon} />
                ) : (
                    <ExpandMore className={classes.icon} />
                )
            ) : null}
            {badge && (
                <Badge className={classes.badge} color="error" badgeContent={badge} />
            )}
        </ListItem>
    );
}

export default PlatformSidebarCategory;
